import { Navigate } from 'react-router-dom';
import { useFeatureFlags, VariantFlags } from '@/services/feature-flag-provider';
import { getQuizletConfig } from './quizlet-config';
import { ROUTE_QUIZLET_V2_QUESTIONNAIRE } from '@/constants/routes';

/**
 * Variant redirect that supports all configured quizlet versions.
 * Uses feature flags to determine which version to redirect to.
 */
const QuizletVariantRedirect = () => {
  const { getVariant, isLoading } = useFeatureFlags();
  const quizletVersion = getVariant(VariantFlags.QuizletVersion);

  // Wait for feature flags to load before redirecting
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Try to find the configuration for the flagged version
  const config = getQuizletConfig(quizletVersion);

  if (config && config.enabled) {
    // Redirect to the configured version's questionnaire path
    return <Navigate to={`${config.basePath}/questionnaire`} replace />;
  }

  // Fallback to v2 questionnaire
  return <Navigate to={ROUTE_QUIZLET_V2_QUESTIONNAIRE} replace />;
};

export default QuizletVariantRedirect;